export const INITIAL_VALUE_SELECT = {
  label: "Selecione",
  value: "",
};

export const SELECT_CATEGORY_INITIAL_VALUE = {
  label: "Categoria",
  value: "",
};

export const CARD_HEADERS_COLORS_TYPES = {
  green: "green",
  default: "default",
  greenDarken: "greenDarken",
  blueDarken: "blueDarken",
};

export const USER_TYPE = {
  ROOT: "root",
  ADMIN: "admin",
  DEV: "dev",
  FINANCIAL: "financial",
  MANAGER: "manager",
  ATTENDANT: "attendant",
  SALE: "sale",
};

export const USER_TYPE_LABELS = {
  DEV: "Desenvolvimento",
  ADMIN: "Administrador",
  SUPORTE: "Suporte",
};

export const PRIVILEGES = {
  ADMIN: USER_TYPE.ADMIN,
  DEV: USER_TYPE.DEV,
  FINANCIAL: USER_TYPE.FINANCIAL,
  MANAGER: USER_TYPE.MANAGER,
  ATTENDANT: USER_TYPE.ATTENDANT,
  ROOT: USER_TYPE.ROOT,
  SALE: USER_TYPE.SALE,
};

export const SELECT_XML_SPED = {
  XML: "XML",
  SPED: "SPED",
};

export const TYPE_DATE = {
  MONTHLY: "mensal",
  DAILY: "diario",
};

export const PREVIA_TIPO = {
  A_PAGAR: "a_pagar",
  CREDITO_ACUMULADO: "credito_acumulado",
};

export const MOVEMENT_TYPE = {
  ENTRADA: "ENTRADA",
  SAIDA: "SAIDA",
};

// Tipos de movimento limpos (run-limpar-tributacao-periodo) antes do
// reprocessamento do Diagnóstico em Tempo Real.
export const DIAGNOSTIC_CLEAN_TAXATION_MOVEMENT_TYPES = [
  MOVEMENT_TYPE.ENTRADA,
  MOVEMENT_TYPE.SAIDA,
];

export const TYPE_MOVEMENT = [
  { label: "Todos", value: "" },
  { label: "Entrada", value: "ENTRADA" },
  { label: "Saída", value: "SAIDA" },
  { label: "Entrada e Saída", value: ["ENTRADA", "SAIDA"] },
  { label: "Transfêrencia Entrada", value: "TRANSF_E" },
  { label: "Transfêrencia Saída", value: "TRANSF_S" },
  { label: "Transfêrencias", value: ["TRANSF_E", "TRANSF_S", "TRANSF"] },
];

// Regimes Tributários (tabela: mxf_regimes_tributarios)
export const REGIME_TRIBUTARIO_IDS = {
  STD: 1, // Padrão
  GOV: 2, // Orgão Governamental
  RURAL: 3, // Produtor Rural
  CONTRI: 4, // Contribuinte
  BER: 5, //Bares e restaurantes
};

export const REGIME_TRIBUTARIO_LABELS = {
  STD: "Padrão",
  GOV: "Orgão Governamental",
  RURAL: "Produtor Rural",
  CONTRI: "Contribuinte",
  BER: "Bares e restaurantes",
};

export const TYPE_MODIFICADOR = {
  MODIFICADOR_CASOS_ESPECIAIS: "modificador-casos-especiais",
  REGIME_TRIBUTARIO_IBS_CBS: "regime-tributario-ibs-cbs",
};

export const REGIMES_ESPECIAIS_TRIBUTARIOS = [
  {
    id: REGIME_TRIBUTARIO_IDS.GOV,
    label: REGIME_TRIBUTARIO_LABELS.GOV,
  },
  {
    id: REGIME_TRIBUTARIO_IDS.RURAL,
    label: REGIME_TRIBUTARIO_LABELS.RURAL,
  },
  {
    id: REGIME_TRIBUTARIO_IDS.CONTRI,
    label: REGIME_TRIBUTARIO_LABELS.CONTRI,
  },
  {
    id: REGIME_TRIBUTARIO_IDS.BER,
    label: REGIME_TRIBUTARIO_LABELS.BER,
  },
];

export const PRODUCT_STATUS_TYPES = {
  ATIVO: "ATIVO",
  CONGELADO: "CONGELADO",
  NOVO: "NOVO",
};

export const CLIENT_LIST_TYPE = {
  NEW_PRODUCTS: "qtd_itens_novos",
  PENDING_REVIEW: "qtd_produtos_faltam_revisao",
  ZERO_SIMILARITY: "qtd_produtos_similaridade_nula",
  FROZEN: "qtd_produtos_congelados",
  REVIEW_DESCRIPTION: "qtd_produtos_rever_descricao",
};
